export default "__VITE_ASSET__DCuFB2iP__"